import classNames from 'classnames';
import { ReactNode, useId } from 'react';
import { PlacesType, PositionStrategy, Tooltip as ReactTooltip } from 'react-tooltip';

type TooltipNewVariant = 'dark' | 'light' | 'success' | 'warning' | 'error' | 'info';

interface TooltipNewProps {
  text: string;
  positionStrategy?: PositionStrategy;
  place?: PlacesType;
  offset?: number;
  showDelay?: number;
  hideDelay?: number;
  html?: string;
  disabled?: boolean;
  className?: string;
  classNameTooltip?: string;
  children: ReactNode;
  variant?: TooltipNewVariant;
}

export const TooltipNew = ({
  text,
  html,
  place,
  disabled,
  className,
  children,
  positionStrategy,
  classNameTooltip,
  offset = 0,
  showDelay = 0,
  hideDelay = 0,
  variant,
}: TooltipNewProps) => {
  const tooltipId = useId();

  return (
    <div
      data-tooltip-id={tooltipId}
      data-tooltip-content={text}
      data-tooltip-html={html}
      data-tooltip-delay-show={showDelay}
      data-tooltip-delay-hide={hideDelay}
      data-tooltip-offset={offset}
      data-tooltip-place={place}
      data-tooltip-position-strategy={positionStrategy}
      className={className}
    >
      {children}
      {!disabled && (
        <ReactTooltip
          id={tooltipId}
          className={classNames('z-10 max-w-[300px]', classNameTooltip)}
          variant={variant}
        />
      )}
    </div>
  );
};
